// @flow

import React from 'react';
import {
  ColumnsHolder,
  LeftColumn,
} from '_common/components/DetailsPage/elements';
import { getInfoBlock } from '_common/utils/utils';
import { returnsBlock, collectionsBlock } from './config';
import DoddleStoresStore from '_common/stores/doddleStoresStore';

const DoddleStoreDetailsServices = ({ data }: { data: DoddleStoresStore }) => {
  return (
    <ColumnsHolder>
      <LeftColumn>{getInfoBlock(collectionsBlock(), true, data)}</LeftColumn>
      <LeftColumn>{getInfoBlock(returnsBlock(), true, data)}</LeftColumn>
    </ColumnsHolder>
  );
};

export default DoddleStoreDetailsServices;
